module.exports = __webpack_public_path__ + "static/media/edit.374125bf.svg";